import { restRequest as e, REST_VERBS as r } from "@ado/base-service";
import { createRequestOptionsBuilder as o } from "../../../../libraries/request_options_building/index.js";
const u = "/api/foundation/user/v1/";
function i() {
  const t = o().setSecureId().build();
  return e(r.POST, `${u}user-auth`, t);
}
export {
  i as getCurrentUserAuth
};
//# sourceMappingURL=index.js.map
